var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('img',{staticClass:"c-crop__img",style:(_vm.imageStyles),attrs:{"src":_vm.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }